export function gridFields() {
  return Object.freeze([{
    key: 'id',
    label: 'lbl.basic.id',
    notInTable: true,
    uneditable: true,
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'name',
    label: 'lbl.basic.name',
    sortable: true,
    form: {
      type: 'input'
    }
  },
  {
    key: 'cycleCount',
    label: 'lbl.teamShift.cycleCount',
    // sortable: true,
    default: 2,
    form: {
      type: 'input',
      options: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ]
    },
  },
  {
    key: 'teamCount',
    label: 'lbl.teamShift.teamCount',
    default: 3,
    form: {
      type: 'input',
      options: [
        { value: 1, text: '1' },
        { value: 2, text: '2' },
        { value: 3, text: '3' },
        { value: 4, text: '4' },
        { value: 5, text: '5' },
      ]
    },
  },
  {
    key: 'startDate',
    label: 'lbl.teamShift.startDate',
    default: today(),
    sortable: true,
    filterable: true,
    form: {
      type: 'date',
    }
  },
  {
    key: 'endDate',
    label: 'lbl.teamShift.endDate',
    default: nextYear(),
    sortable: true,
    filterable: true,
    form: {
      type: 'date',
    }
  },
  {
    key: 'firstStartTime',
    label: 'lbl.teamShift.firstStartTime',
    filterable: true,
    default: '08:00',
    form: {
      type: 'time',
    }
  },
  {
    key: 'locationId',
    label: 'lbl.teamShift.locationId',
    sortable: true,
    notInTable: true,
    form: {
      type: 'dimSearch',
      url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
      config: {
        validate: "", // 参数检查，可以是正则表达式等
        bindId: 'teamShiftLoc', // 绑定的 id, (id 相同的对象会被绑定)
        bindProp: "id", // 显示的属性的名称
        submitProp: "id" // 提交的属性
      }
    }
  },
  {
    key: 'locationName',
    label: 'lbl.teamShift.locationName',
    sortable: true,
    filterable: true,
    form: {
      type: 'dimSearch',
      url: process.env.VUE_APP_MASTER_API_URL + 'master-service/master/location/findAll',
      config: {
        validate: "", // 参数检查，可以是正则表达式等
        bindId: 'teamShiftLoc', // 绑定的 id, (id 相同的对象会被绑定)
        bindProp: "locName", // 显示的属性的名称
        submitProp: "locName" // 提交的属性
      }
    }
  }
  ]);
}

function nextYear() {
  const current = new Date;
  return current.getFullYear() + 1 + "-" + current.getMonth() + "-" + current.getDate();
}

function today() {
  let date = new Date;
  return date.getFullYear() + "-" + (date.getMonth()+1) + "-" + date.getDate();
}

// class
export const TeamShift = function (...args) {
  gridFields().forEach(item => {
    this[item.key] = item.default || '';
  })
}


export const filter = gridFields()
  .filter(v => v.filterable)
  .reduce((tar, v) => {
    tar[`${v.key}Filter`] = '';
    return tar
  }, {})
export const filterFields = gridFields().filter(v => v.filterable).map(v => `filter.${v.key}`)